export default {
  methods: {
    dropdownValues(localeKey) {
      const c = this.$t(localeKey);
      if (_.isArray(c)) {
        return c;
      }
      return _.map(c, (v, k) => ({ value: k, label: v }));
    },
  }
};
